export default {
  EAST: "EAST",
  WEST: "WEST",
  NORTH: "NORTH",
  SOUTH: "SOUTH"
};



// WEBPACK FOOTER //
// ./src/constants/directions.js